import {
  ElectoralListIdMetaKey,
  FormBuilderMetaFlags,
  type ICreateWidgetFormSchemaInput,
} from '@framework/engine';
import { yup } from '@framework/validation';
import { fromPairs } from 'lodash';
import { getWidgetCandidateColumns } from './form/getWidgetCandidateColumns';
import { getDatatypeColumnSchema } from './getDatatypeColumnSchema';
import type { ICandidateWidget } from './ICandidateWidget';

export function candidateSelectWidgetObjectName(code: string) {
  return `${code}@columns`;
}

export function createCandidateSelectFormSchema(
  input: ICreateWidgetFormSchemaInput<ICandidateWidget>,
) {
  const { widget } = input;

  const objectSchema = yup
    .object(
      fromPairs(
        getWidgetCandidateColumns(widget).map(column => [
          column.name,
          getDatatypeColumnSchema(column.type),
        ]),
      ),
    )
    .formBuilderFlags(
      FormBuilderMetaFlags.SkipDefaultValue,
      FormBuilderMetaFlags.SkipValidationRules,
    );

  // Schema per il valore del candidato selezionato con electoralListId nei metadati
  const candidateSchema = yup
    .string()
    .notRequired()
    .meta({
      [ElectoralListIdMetaKey]: widget.electoralListId,
    });

  return {
    [widget.code]: candidateSchema,
    [candidateSelectWidgetObjectName(widget.code)]: objectSchema.notRequired(),
  };
}
